/**
 * News components: clock + newsFeed
 */

document.addEventListener('alpine:init', () => {
  /**
   * Clock
   * A live HH:MM clock that ticks once per minute.
   */
  window.Alpine.data('clock', () => ({
    hours: '',
    minutes: '',
    iso: '',
    timer: null,
    onVisible: null,

    init() {
      this.tick();
      // Tick once a second rather than once a minute. Cheap — we only
      // assign the reactive props when the displayed value actually
      // changes, so Alpine only re-renders at the minute boundary. The
      // second-rate tick means we self-correct quickly after the browser
      // throttled the timer (background tab, sleep/wake), instead of
      // sitting on a stale value for up to a full minute.
      this.timer = window.setInterval(() => this.tick(), 1000);

      // When the tab becomes visible again, force an immediate tick —
      // browsers throttle setInterval in background tabs, so the timer
      // can drift or pause until focus returns.
      this.onVisible = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVisible);
    },

    destroy() {
      if (this.timer)     window.clearInterval(this.timer);
      if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
    },

    tick() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const h = pad(d.getHours());
      const m = pad(d.getMinutes());
      // Guard each assignment so Alpine only re-renders when something
      // actually changed — keeps the per-second tick essentially free.
      if (h !== this.hours)   this.hours   = h;
      if (m !== this.minutes) this.minutes = m;
      this.iso = d.toISOString();
    },
  }));

  /**
   * News Feed
   * Progressive reveal of news cards.
   * All posts are rendered server-side (for SEO/indexability) but
   * CSS hides cards beyond the `revealed` count. As the sentinel
   * intersects, we bump `revealed` by `perLoad` until all are shown.
   */
  window.Alpine.data('newsFeed', ({ perLoad = 9, total = 0 } = {}) => ({
    revealed: perLoad,
    perLoad,
    total,

    loadMore() {
      if (this.revealed >= this.total) return;
      this.revealed = Math.min(this.revealed + this.perLoad, this.total);
    },
  }));
});
